/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDeviceTrendPointsRequest = {
  agentId: string;
};

/** @internal */
export type ListDeviceTrendPointsRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const ListDeviceTrendPointsRequest$outboundSchema: z.ZodType<
  ListDeviceTrendPointsRequest$Outbound,
  z.ZodTypeDef,
  ListDeviceTrendPointsRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listDeviceTrendPointsRequestToJSON(
  listDeviceTrendPointsRequest: ListDeviceTrendPointsRequest,
): string {
  return JSON.stringify(
    ListDeviceTrendPointsRequest$outboundSchema.parse(
      listDeviceTrendPointsRequest,
    ),
  );
}
